export const getCookie = (name: string) => {
	const cookie = document.cookie.split('; ').find((cookie) => {
		const parts = cookie.split('=');
		return parts[0] === name;
	});
	return cookie ? cookie.split('=')[1]! : '';
};
